import { rootApi } from '../rootApi';

export const countryApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllCountries: builder.query({
            query: (params) => ({
                url: 'v1/systemdefinitions/getcountries',
                method: 'GET',
                params: {
                    LanguageId: params?.languageId || 1
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return response.data.items;
                }
                if (Array.isArray(response)) {
                    return response;
                }
                return [];
            },
            providesTags: [{ type: 'Country', id: 'LIST' }]
        }),
        getCountryByKunnr: builder.query({
            query: ({ dealerId, languageId }) => ({
                url: 'v1/systemdefinitions/GetCountriesByKunnr',
                method: 'GET',
                params: {
                    DealerId: dealerId,
                    LanguageId: languageId
                }
            }),
            transformResponse: (response) => {
                const d = response && response.data ? response.data : {};
                return {
                    countryCode: d.countryCode || '',
                    countryName: d.countryName || ''
                };
            }
        }),
        getCountriesFromSapDealer: builder.query({
            query: (params) => ({
                url: 'v1/systemdefinitions/GetCountriesFromSapDealer',
                method: 'GET',
                params: {
                    LanguageId: params?.languageId || 1
                }
            }),
            transformResponse: (response) => {
                if (response && Array.isArray(response.data)) {
                    return response.data;
                }
                if (response && response.data && Array.isArray(response.data.items)) {
                    return response.data.items;
                }
                if (Array.isArray(response)) {
                    return response;
                }
                return [];
            },
            providesTags: [{ type: 'Country', id: 'LIST' }]
        })
    })
});

export const { useGetAllCountriesQuery, useGetCountryByKunnrQuery, useGetCountriesFromSapDealerQuery } = countryApi;
